import toast from 'react-hot-toast';

import { GET } from "../../../API/get";
import { POST } from "../../../API/post";
import { DELETE } from '../../../API/delete';
import { PUT } from '../../../API/put';
import { getUserInfo } from "../../../storage";
import { commonSwal } from '../../../components/swalAlert/swalAlert';

export const getNotes = async (ftm_id, dispatch) => {
    dispatch({ type: "IS_LOADING" });
    let response = await GET(`/ftm/note/${ftm_id}`);

    if (response.status === "Success") {
        dispatch({
            type: 'SET_NOTE_LIST',
            notes_list: response.list
        });
    }
}

export const saveNote = async (data, ftm_id, dispatch, reset) => {
    dispatch({ type: "IS_LOADING" });

    let user_info = getUserInfo();
    let response = await POST(`/ftm/note`, {
        ftm_id: ftm_id,
        admin_user_id: user_info.admin_id,
        ftm_note: data.note,
        ftm_is_notes_followup: data.ftm_is_notes_followup ? 1 : 0
    });

    if (response.status === "Success") {
        reset();
        getNotes(ftm_id, dispatch);
    } else {
        dispatch({ type: "IS_LOADED" });
    }
}

export const editNote = async (event, ftm_note_id, ftm_id, dispatch, reset) => {
    event.preventDefault();

    dispatch({ type: "BTN_LOADING", btn_loading: true });
    let response = await PUT("update/ftm/note", {
        ftm_note_id: ftm_note_id,
        ftm_note: event.target.elements.ftm_note.value
    });

    if (response.status === "Success") {
        reset();
        dispatch({ type: "RESET_EDIT_NOTE" });
        toast.success(response.message);
        getNotes(ftm_id, dispatch);
    }
}

export const deleteNote = async (ftm_note_id, ftm_id, dispatch) => {
    commonSwal({
        notificationType: 'DELETE_NOTE',
        preConfirm: async () => {
            let response = await DELETE(`delete/ftm/note/${ftm_note_id}`);
            return response;
        },
        isConfirmed: (result) => {
            if (result.isConfirmed) {
                if (result.value.status === "Success") {
                    toast.success(result.value.message)
                    getNotes(ftm_id, dispatch);
                } else {
                    toast.error(result.value.message);
                }
            }
        }
    })
}

export const SetFollowupReminderDate = async (ftm_id, followup_reminder_date) => {
    let user_info = getUserInfo();
    let response = await PUT("ftm/notes/followup/reminder", {
        ftm_id,
        followup_reminder_date,
        admin_id: user_info.admin_id,
    });

    return response?.status === "Success" ? response : null;
}